export class PaymentType {
  public id?: string;
  public name: string;
}
